// extracted by mini-css-extract-plugin
export default {"formOneLine":"ClientPricelist_formOneLine__ZcrHX"};